<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 14px;
}

.protocol-content {
  overflow-y: auto;
  max-height: calc(100vh - 50vh);
  font-size: 16px;
  line-height: 1.6;
  color: #040a16;
}

* {
  list-style: none;
}

.ques-form {
  max-width: 1180px;
  padding: 76px 32px;
  box-sizing: border-box;
}

.ques-item,
.ques-group {
  .ques-title {
    font-size: 14px;
    line-height: 32px;
    color: #191919;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    font-weight: bold;

    .title-text {
      margin-right: 0.2em;
      text-align: justify;
    }

    .is-required {
      color: #e02128;
      margin-right: 5px;
    }
  }

  &+.ques-item {
    margin-top: 16px;
  }

  .radio-item,
  .checkbox-item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .radio-text,
    .checkbox-text {
      display: flex;
      align-items: center;
    }

    .opt-text {
      font-size: 14px;
      line-height: 22px;
      color: #191919;
    }

    &+.radio-item,
    &+.checkbox-item {
      margin-top: 12px;
    }

    &:nth-last-of-type(n + 2) {
      .probe {
        margin-bottom: 12px;
      }
    }
  }

  .score-item {
    .score-box {
      width: var(--w);
      border-bottom: 1px solid #e4e3e3;
      padding-bottom: 6px;
    }

    .opt-text {
      font-size: 14px;
      line-height: 22px;
      color: #191919;
      margin-bottom: 12px;
    }

    .score-radio,
    .stage {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .score-radio {
      margin-top: 12px;
      margin-bottom: 10px;

      .li {
        width: 28px;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 24px;

        .score-num {
          font-size: 14px;
          line-height: 22px;
          color: #191919;
          margin-bottom: 8px;
        }

        .rate-radio {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 100%;
          box-sizing: border-box;
          border: 1px solid #595959;
          position: relative;
          transition: all 0.3s ease-in-out;
          cursor: pointer;

          &::after {
            content: "";
            width: 5px;
            height: 5px;
            border-radius: 100%;
            background: #fff;
            box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
            transition: all 0.3s ease-in-out;
            transform: translate(-50%, -50%) scale(0);
            position: absolute;
            top: 50%;
            left: 50%;
          }

          &.light {
            background: #0067d1;
            border-color: #0067d1;

            &::after {
              transform: translate(-50%, -50%) scale(1);
            }
          }
        }
      }
    }

    .stage {
      font-size: 12px;
      line-height: 20px;
      color: #191919;
      justify-content: space-between;
    }

    &+.score-item {
      .score-box {
        margin-top: 8px;
      }
    }

    &:nth-last-of-type(n + 2) {
      .probe {
        margin-bottom: 12px;
      }
    }
  }

  .probe {
    width: 100%;
    margin-top: 12px;

    .probe-text {
      font-size: 14px;
      line-height: 22px;
      color: #191919;
      margin-bottom: 12px;
    }
  }
}

.ques-group {
  .ques-tips {
    font-size: 14px;
    color: #595959;
    line-height: 22px;
    margin-bottom: 12px;
  }

  .form-item-group {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .el-form-item {
      width: calc((100% - 110px) / 2);
    }
  }

  .custom-radio {
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    .radio {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      box-sizing: border-box;
      border: 1px solid #595959;
      margin-right: 9px;
      position: relative;

      &::after {
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        transition: transform 0.15s ease-in;
      }

      &.checked {
        background: #0067d1;
        border-color: #0067d1;

        &::after {
          transform: translate(-50%, -50%) scale(1);
        }
      }
    }

    .label {
      font-size: 14px;
      color: #191919;
      line-height: 22px;
    }
  }

  .protocolTitle {
    display: flex;
    align-items: center;
    cursor: pointer;
    //font-size: 14px;
  }

  .c-blue {
    color: #409EFF;
    cursor: pointer;
    margin: 0 3px;
  }

  ::v-deep {
    .el-form-item {
      &__error {
        padding-top: 0;
        left: 100%;
        transform: translateX(-100%);
      }
    }
  }
}

.sub-btn {
  width: 100%;
  box-sizing: border-box;
  padding-left: 134px;
  text-align: center;

  .el-button {
    width: 120px;
    height: 40px;
    background: #0067d1;
    border: none;
    line-height: 40px;
    color: #fff;
    border-radius: 20px;
    font-size: 16px;
    margin: 140px 0 40px;
    padding: 0;
  }
}

::v-deep {
  .el-form {
    &-item {
      margin-bottom: 12px;

      &__label {
        font-size: 14px;
        color: #191919 !important;
        line-height: 22px;
        height: 34px;
        padding-bottom: 12px;
        display: flex;
        align-items: center;

        &::before {
          color: #e02128 !important;
          margin-right: 5px !important;
          margin-bottom: -4px;
        }
      }

      &__content {
        min-height: 32px;

        .el-input {
          &__inner {
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            border-color: #dfdfdf;
            color: #191919;

            &::placeholder {
              color: #aeaeae;
            }

            &:focus {
              border-color: #0067d1;
            }
          }

          &-group {
            .el-input__inner {
              width: calc(100% + 72px) !important;
              padding-right: 87px;
            }

            &__append {
              width: 72px;
              height: 32px;
              padding: 0;
              border-radius: 4px;
              background: #0067d1;
              border: none;
              text-align: center;

              .el-button {
                width: 100%;
                height: 100%;
                padding: 0;
                font-size: 12px;
                color: #fff;
                line-height: 32px;
                text-align: center;
                border: none;

                &.is-disabled {
                  background: rgba($color: #fff, $alpha: 0.2);
                }

                &.is-disabled:hover,
                &.is-disabled:focus {
                  background: rgba($color: #fff, $alpha: 0.2);
                  cursor: default;
                }
              }
            }
          }
        }

        .el-select {
          width: 100%;
        }

        .el-input.is-focus .el-input__inner {
          border-color: #0067d1;
        }
      }

      &__error {
        white-space: nowrap;
        color: #e02128 !important;
      }

      &.is-error {
        margin-bottom: 24px;

        .el-input__inner,
        .el-input__inner:focus,
        .el-textarea__inner,
        .el-textarea__inner:focus {
          border-color: #e02128;
        }
      }
    }
  }

  .el-tag {
    height: 24px;
    line-height: 24px;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    padding: 0 8px;
    color: #0067d1;
    background: #e6f1fd;
    display: inline-flex;
    align-items: center;
    cursor: default;
    margin-top: 6px;
    font-weight: normal;

    &--info {
      color: #191919;
      background: #f5f6f8;
    }
  }

  .el-textarea {
    border: none;

    &__inner {
      min-height: 48px !important;
      padding: 6px 12px;
      line-height: 22px;
      border: 1px solid #c9c9c9;
      border-radius: 4px;
      font-size: 14px;
      color: #191919;

      &::placeholder {
        color: #aeaeae;
      }

      &:focus {
        border-color: #0067d1;
      }
    }

    &.large .el-textarea__inner {
      min-height: 98px !important;
    }
  }

  .el-checkbox,
  .el-radio {
    line-height: 22px;
    margin-right: 12px;
    display: inline-flex;
    align-items: center;

    &-group {
      width: 100%;
    }

    .el-checkbox,
    .el-radio {
      &__input {
        &.is-checked {

          .el-checkbox,
          .el-radio {
            &__inner {
              border-color: #0067d1;
              background: #0067d1;

              &::after {
                box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
              }
            }
          }

          .el-checkbox__inner::after {
            transform: rotate(0deg) scale(0.7);
          }
        }

        .el-checkbox,
        .el-radio {
          &__inner {
            border-color: #595959;

            &:hover {
              border-color: #0067d1;
            }
          }
        }

        .el-radio__inner {
          &::after {
            content: "";
            width: 5px;
            height: 5px;
            background: #fff;
          }
        }

        .el-checkbox__inner {
          border-radius: 3px;

          &::after {
            content: "\e6da";
            font-family: element-icons !important;
            transform: rotate(0deg) scale(0);
            border: none;
            color: #fff;
            font-size: 12px;
            top: 1px;
            left: 1px;
            text-shadow: 1px 3px 0px rgba(0, 0, 0, 0.3);
          }
        }
      }

      &__inner {
        width: 14px;
        height: 14px;
      }

      &__label {
        padding-left: 8px;
        font-weight: normal;
        color: #191919;
      }
    }
  }
}

.yanjin {
  position: relative;

  &.close::after {
    content: "";
    position: absolute;
    width: 70%;
    height: 1px;
    left: 15%;
    top: 50%;
    background-color: #999999;
    margin-top: -1px;
    transform: rotate(30deg);
  }

  padding: 0 5px;
  cursor:pointer;
}
</style>

<style lang="scss">
.el-select-dropdown__item.selected {
  color: #0067d1;
}
</style>

<template>
  <div>

    <el-form class="ques-form" ref="quesForm" :model="quesForm" label-position="top" :rules="rules">
      <div class="ques-list">
        <div class="ques-item" v-for="(que, qi) in quesForm.ques" :key="que.tqs_id">
          <div class="ques-title">
            <span class="ques-no">{{ qi + 1 }}、</span>
            <p class="title-text">{{ ques[qi].tqs_content }}</p>
            <span class="is-required" v-if="ques[qi].tqs_is_required == 10">*</span>
            <el-tag type="info" size="small">{{ ques[qi].tqs_type_text }}</el-tag>
          </div>

          <!-- 单选题 -->
          <template v-if="que.tqs_type == 10">
            <el-form-item :prop="`ques.${qi}.tqa_tqo_id`"
              :rules="ques[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请选择') }] : []">
              <el-radio-group v-model="que.tqa_tqo_id">
                <div class="radio-ls">
                  <div class="radio-item" v-for="opt in ques[qi].options" :key="opt.tqo_id">
                    <el-radio style="width: 1180px;" :label="opt.tqo_id">{{ opt.tqo_content }}</el-radio>
                  </div>
                </div>
              </el-radio-group>
            </el-form-item>
            <div class="probe" v-if="que.tqs_is_probe == 10 && ques[qi].tqs_probe != ''">
              <p class="probe-text">{{ ques[qi].tqs_probe }}</p>
              <!-- <el-form-item :prop="`ques.${qi}.tqa_probe`" :rules="ques[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请输入') }] : []"> -->
              <el-form-item :prop="`ques.${qi}.tqa_probe`">
                <el-input v-model="que.tqa_probe" type="textarea" :placeholder="$t('请输入')" resize="none" />
              </el-form-item>
            </div>
          </template>
          <!-- 单选题 -->
          <!-- <el-form-item
          v-if="que.tqs_type == 10"
          :prop="`ques.${qi}.tqa_tqo_id`"
          :rules="{ required: ques[qi].tqs_is_required, message: '请选择' }"
        >
          <el-radio-group v-model="que.tqa_tqo_id">
            <div class="radio-ls">
              <div class="radio-item" v-for="(opt,oi) in ques[qi].options" :key="opt.tqo_id">
                <el-radio :label="opt.tqo_id">{{ opt.tqo_content }}</el-radio>
              </div>
            </div>
          </el-radio-group>
        </el-form-item> -->
          <!-- 多选题 -->
          <template v-if="que.tqs_type == 20">
            <el-form-item :prop="`ques.${qi}.tqa_tqo_id`"
              :rules="ques[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请选择') }] : []">
              <el-checkbox-group v-model="que.tqa_tqo_id" @change="handleCheckboxChange(qi, $event)">
                <div class="checkbox-ls">
                  <div class="checkbox-item" v-for="opt in ques[qi].options" :key="opt.tqo_id">
                    <el-checkbox :label="opt.tqo_id" :disabled="isCheckboxDisabled(qi, opt.tqo_id)">
                      {{
                        opt.tqo_content
                      }}
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </el-form-item>
            <div class="probe" v-if="ques[qi].tqs_is_probe == 10 && ques[qi].tqs_probe != ''">
              <p class="probe-text">{{ ques[qi].tqs_probe }}</p>
              <!-- <el-form-item :prop="`ques.${qi}.tqa_probe`" :rules="ques[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请输入') }] : []"> -->
              <el-form-item :prop="`ques.${qi}.tqa_probe`">
                <el-input v-model="que.tqa_probe" type="textarea" :placeholder="$t('请输入')" resize="none" />
              </el-form-item>
            </div>
          </template>
          <!-- 评分题 -->
          <template v-if="que.tqs_type == 30">
            <el-form-item class="score-item" v-for="(opt, oi) in ques[qi].options" :key="opt.tqo_id"
              :prop="`ques.${qi}.options.${oi}.tqa_score`"
              :rules="ques[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请选择') }] : []">
              <div class="score-box" :style="{
                '--w': 52 * ((opt.tqo_score_high > 10 && 10) || opt.tqo_score_high) + 'px',
              }">
                <span class="opt-text">{{ opt.tqo_content }}</span>
                <div class="score-radio">
                  <div v-for="score in (opt.tqo_score_high > 10 && 10) ||
                    opt.tqo_score_high" :key="score"
                    @click="que.options[oi].tqa_score = opt.tqo_score_high > 10 ? score * 10 : score" class="li">
                    <span class="score-num">{{ opt.tqo_score_high > 10 ? score * 10 : score }}</span>
                    <span class="rate-radio"
                      :class="{ light: (opt.tqo_score_high > 10 ? score * 10 : score) == que.options[oi].tqa_score }" />
                  </div>
                </div>
                <p class="stage">
                  <span>{{ opt.tqo_stage_low }}</span>
                  <span>{{ opt.tqo_stage_high }}</span>
                </p>
              </div>
            </el-form-item>
            <div class="probe" v-if="ques[qi].tqs_is_probe == 10 && ques[qi].tqs_probe != ''">
              <p class="probe-text">{{ ques[qi].tqs_probe }}</p>
              <!-- <el-form-item :prop="`ques.${qi}.tqa_probe`" :rules="ques[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请输入') }] : []"> -->
              <el-form-item :prop="`ques.${qi}.tqa_probe`">
                <el-input v-model="que.tqa_probe" type="textarea" :placeholder="$t('请输入')" resize="none" />
              </el-form-item>
            </div>
          </template>
          <!-- 主观题 -->
          <el-form-item v-if="que.tqs_type == 40" :prop="`ques.${qi}.tqa_anwser`"
            :rules="ques[qi].tqs_is_required === 10 ? [{ required: true, message: $t('请输入') }] : []">
            <el-input v-model="que.tqa_anwser" class="large" type="textarea" :placeholder="$t('请输入')" resize="none" />
          </el-form-item>
        </div>

       
      </div>
      <el-form-item class="sub-btn">
        <el-button @click="subForm">{{ $t('提交问卷') }}</el-button>
      </el-form-item>

      <!-- 协议弹窗 -->
      <el-dialog :visible.sync="dialogVisible" width="80%" :before-close="handleClose" :title="protocolTitle">
        <!-- 协议内容渲染 -->

        <div class="protocol-content">
          <div v-html="protocolContent"></div>
        </div>
      </el-dialog>
    </el-form>

    <verify ref="verifyModal" @success="verifySuccess" />
  </div>

</template>

<script>
import verify from "../../login/components/verify.vue";
import {
  getQuestionCountry,
  getAreacode,
  isAnswer,
  sendMbileCode,
  sendCodeEmail,
  getUserInfoSet,
  answerCheckCode,
  answerAdd,
  getAgreen,
} from "@api/questionnaire";
import { validEmail, validPhone } from "@utils/validate";
export default {
  name: "QuesList",
  components: {
    verify
  },
  props: {
    ques: {
      type: Array,
      default: () => [],
    },
    tqId: {
      type: [Number, String],
      default: () => { },
    },
    twsId: {
      type: [Number, String],
      default: () => { },
    },
    inCn: {
      type: [Number, String],
      default: () => { },
    },
    taId: {
      type: [Number, String],
      default: () => { },
    },

  },
  watch: {
    ques: {
      handler(n) {
        //console.log(n);
        n.map((item) => {
          let obj = {
            tqs_id: item.tqs_id,
            tqs_type: item.tqs_type,
            tqs_is_probe: item.tqs_is_probe,
            tqa_anwser: "",
            tqa_tqo_id: "",
            tqa_tqo_probe_arr: [],
            options: [],
          };
          if (item.tqs_type == 10 || item.tqs_type == 20) {
            item.options.map((oitem) => {
              obj.tqa_tqo_probe_arr.push({ [oitem.tqo_id]: "" });
            });
          }
          /* 多选 */
          if (item.tqs_type == 20) {
            obj.tqa_tqo_id = [];
          } else if (item.tqs_type == 30) {
            /* 评分 */
            item.options.map((opt) => {
              obj.options.push({
                tqo_id: opt.tqo_id,
                tqa_score: null,
                tqa_tqo_probe: "",
              });
            });
          }
          this.quesForm.ques.push(obj);
        });
        this.$forceUpdate();
      },
      immediate: true,
    },
    tqId: {
      handler(n) {
        this.tq_id = n;
      },
      immediate: true,
    },
    twsId: {
      handler(n) {
        this.tws_id = n;
      },
      immediate: true,
    },
    inCn: {
      handler(n) {
        this.in_cn = n;
      },
      immediate: true,
    },
    taId: {
      handler(n) {
        this.ta_id = n;
      },
      immediate: true,
    },
  },
  data() {
    let validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('请输入邮箱')));
      } else {
        callback();
      }
      // else {
      //   if (!validEmail(value)) {
      //     callback(new Error("请输入正确的邮箱地址"$t('请输入邮箱')));
      //   } else {
      //     callback();
      //   }
      // }
    };
    let validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('请输入电话')));
      } else {
        callback();
      }
      // else {
      //   if (!validPhone(value)) {
      //     callback(new Error("请输入正确的手机号码"));
      //   } else {
      //     callback();
      //   }
      // }
    };
    return {

      // 图形验证
      isNew: true,

      aes_key: 'ed8222',
      aes_script: '8NONwyJt',



      send_btn: this.$t('发送验证码'),
      send_cold: 0,
      send_cd: null,
      quesForm: {
        ques: [],
        user_info: {
          register_type: 10, // 外网默认20: 邮箱,国内默认10: 手机号
          user_name: "", // 用户名
          user_mobile_area_code: "", //区号
          user_mobile: "", //手机号
          user_email: "", // 邮箱
          register_country: "", // 国家
          user_company: "", // 公司
          user_role: [], // 角色
          user_job: "",//职位
          user_industry: "", // 行业
          radioIsAgree: 1, // 是否同意注册为Oceanclub会员
          code: '',
        },
      },
      rules: {
        "user_info.register_type": [
          { required: true, message: this.$t('请选择录入方式'), trigger: "change" },
        ],
        "user_info.user_mobile_area_code": [
          { required: true, message: this.$t('请选择国家/区域'), trigger: "change" },
        ],
        "user_info.user_mobile": [
          { required: true, validator: validatePhone, trigger: "blur" },
        ],
        "user_info.code": [
          { required: true, message: this.$t('请填写验证码'), trigger: "blur" },
        ],
        "user_info.user_email": [
          { required: true, validator: validateEmail, trigger: "blur" },
        ],
        "user_info.user_name": [
          { required: true, message: this.$t('请输入姓名'), trigger: "blur" },
        ],
        "user_info.register_country": [
          { required: true, message: this.$t('请选择国家/区域'), trigger: "change" },
        ],
        "user_info.user_company": [
          { required: true, message: this.$t('请输入公司名称'), trigger: "blur" },
        ],
        "user_info.user_role": [
          { required: true, message: this.$t('请选择角色'), trigger: "change" },
        ],
        "user_info.user_job": [
          { required: true, message: this.$t('请选择职位'), trigger: "change" },
        ],
        "user_info.user_industry": [
          { required: true, message: this.$t('请选择行业'), trigger: "change" },
        ],
      },
      countryList: [],
      tq_id: '',
      areacode: '',
      userJobData: [],
      userRoleData: [],
      userIndustryData: [],
      shouldShowIsAgree: true,
      agreenContent: {
        privacyPro: '',
        registerPro: '',
        registerProTitle: '',
        privacyTitle: ''
      },
      consent: true,
      dialogVisible: false,      // 控制弹窗显示
      currentProtocolType: '',   // 当前协议类型（privacyPro / registerPro）
      protocolContent: '',       // 协议文本内容
      protocolTitle:'',
      tws_id:'',
      in_cn:'',
      looktype:false,
      user_id:'',
      ta_id:'',
      protocolTitle: '',
      tws_id: '',
      in_cn: '',
      looktype: false,
      user_id: ''
    };
  },

  created() {
    // 获取初始化数据
    this.initData();
    //console.log(this.tws_id)
    if (this.in_cn == 1) {
      this.quesForm.user_info.register_type = 10;
    } else {
      this.quesForm.user_info.register_type = 20;
    }
  },
  methods: {

    verifySuccess() {
      this.sendCode();
    },
    resetValidation(e) {
      this.$refs.quesForm.clearValidate(["user_info.user_mobile", "user_info.user_email", "user_info.code", "user_info.user_mobile_area_code"]); // 重置指定字段的验证
    },
    async initData() {
      const res = await getQuestionCountry();
      if (res.status == 200) {
        this.countryList = res.data.country_list;
      }
      const userInfoSet = await getUserInfoSet();
      this.userJobData = userInfoSet.data.user_job_options
      this.userRoleData = userInfoSet.data.user_role_options
      this.userIndustryData = userInfoSet.data.user_industry_options
      const res2 = await getAgreen();
      if (res2.status == 200) {
        this.agreenContent.registerPro = res2.data.registerPro.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
        this.agreenContent.privacyPro = res2.data.privacyPro.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
        this.agreenContent.registerProTitle = res2.data.privacyProTitle
        this.agreenContent.privacyTitle = res2.data.registerProTitle
      }
    },
    async getAreacode(value) {
      const areacode = await getAreacode({
        ddt_value: value
      });
      if (areacode.status == 200) {
        this.areacode = areacode.data.ddt_area_code;

      }
    },
    agreenChange(val) {
      console.log(val)
    },
    // 打开协议弹窗
    openAgreenPop(type) {
      this.currentProtocolType = type
      if (type == 'privacyPro') {
        this.protocolContent = this.agreenContent.registerPro
        this.protocolTitle = this.agreenContent.registerProTitle
      } else {
        this.protocolContent = this.agreenContent.privacyPro
        this.protocolTitle = this.agreenContent.privacyTitle
      }
      this.dialogVisible = true
    },
    // 关闭弹窗前确认
    handleClose(done) {
      done();
    },
    /**
     * 是否同意注册会员
     * @param val
     */
    toggleSelection(val) {
      if (this.quesForm.user_info.radioIsAgree === val) {
        this.quesForm.user_info.radioIsAgree = 0; // 取消选中
      } else {
        this.quesForm.user_info.radioIsAgree = val; // 选中
      }
    },
    /**
     * 发送验证码
     */
    async sendCode() {

      if (this.quesForm.user_info.register_type == 10) {
        //发送手机短信验证码
        if (this.quesForm.user_info.user_mobile_area_code == '') {
          this.$refs.quesForm.validateField('user_info.user_mobile_area_code')
          return false;
        }
        if (this.quesForm.user_info.user_mobile == '') {
          this.$refs.quesForm.validateField('user_info.user_mobile')
          return false;
        }
        //4.10号验证码临时修改
        this.sendVerificationCode();
        //this.generateCaptcha();
      } else {

        //发送邮箱验证码
        if (this.quesForm.user_info.user_email == '') {
          this.$refs.quesForm.validateField('user_info.user_email')
          return false;
        }
        this.sendVerificationCode();

      }

    },
    generateCaptcha() {
      this.chageSendStatus();
      // setTimeout(() => {
      //   let captcha = '';
      //   for (let i = 0; i < 6; i++) {
      //   captcha += Math.floor(Math.random() * 10); // 随机生成一个数字
      //   } 
      //   this.quesForm.user_info.code = captcha;// 更新验证码

      //   this.handleBlur()
      // }, 2000);

    },
    async sendVerificationCode() {
      if (this.quesForm.user_info.register_type == 10) {
        let isAn = await isAnswer({
          mobile: this.quesForm.user_info.user_mobile,
          tq_id: this.tq_id,
          selectEnterTtype: this.quesForm.user_info.register_type,
          tqau_tq_type: 10,
          tqau_content_id: this.ta_id
        });
        if (isAn.status == 200) {

          let phone = this.isNew ? this.$encryptByAES(this.quesForm.user_info.user_mobile, this.aes_key, this.aes_script) : this.quesForm.user_info.user_mobile;

          let sendCode = await sendMbileCode({
            phone: phone,
            px: 'regis_',
            areacode: this.areacode,
          });

          if (sendCode.status == '400C1' && this.isNew) {
            this.$refs.verifyModal.openModal(phone);
            return false;
          }

          if (sendCode.status == 200) {
            // this.generateCaptcha();
            this.chageSendStatus();
          }
          this.generateCaptcha();
        }
      } else {
        let isAn = await isAnswer({
          email: this.quesForm.user_info.user_email,
          tq_id: this.tq_id,
          selectEnterTtype: this.quesForm.user_info.register_type,
          tqau_tq_type: 10,
          tqau_content_id: this.ta_id
        });
        if (isAn.status == 200) {
          let sendCode = await sendCodeEmail({
            email: this.quesForm.user_info.user_email,
            px: 'regis_',
          });
          //4.17注释
          if (sendCode.status == 200) {
            this.chageSendStatus();
          }
          this.generateCaptcha();
        }

      }
    },
    generateCaptcha() {
      // let captcha = '';
      // for (let i = 0; i < 6; i++) {
      // captcha += Math.floor(Math.random() * 10); // 随机生成一个数字
      // }
      // this.quesForm.user_info.code = captcha;// 更新验证码
      this.chageSendStatus();
      // this.handleBlur()
    },
    chageSendStatus() {
      if (this.send_cd) {
        clearInterval(this.send_cd);
        this.send_cd = null;
      }
      this.send_cold = 60;
      this.send_btn = `${this.send_cold}s`;
      this.send_cd = setInterval(() => {
        this.send_cold--;
        if (this.send_cold <= 0) {
          this.send_btn = this.$t('发送验证码');
          clearInterval(this.send_cd);
          this.send_cd = null;
        } else {
          this.send_btn = `${this.send_cold}s`;
        }
      }, 1000);
    },
    async handleBlur() {
      if (this.quesForm.user_info.code.length === 6 || this.quesForm.user_info.code.length === 8) {
        // 验证码输入完成，执行查询用户信息的操作
        const userData = await answerCheckCode({
          mobile: this.quesForm.user_info.user_mobile,
          email: this.quesForm.user_info.user_email,
          yzmCode: this.quesForm.user_info.code,
          areacode: this.areacode,
          register_type: this.quesForm.user_info.register_type
        });
        if (userData.status == 200) {
          //console.log(userData)

          if (userData.data.user_id != '') {
            this.user_id = userData.data.user_id;
            this.shouldShowIsAgree = false;
            this.quesForm.user_info.user_id = userData.data.user_id
            this.quesForm.user_info.user_mobile = userData.data.user_mobile
            this.quesForm.user_info.user_email = userData.data.user_email
            this.quesForm.user_info.user_name = userData.data.user_name
            this.quesForm.user_info.register_country = userData.data.register_country
            this.quesForm.user_info.user_company = userData.data.user_company
            this.quesForm.user_info.user_job = parseInt(userData.data.user_job)
            this.quesForm.user_info.user_role = userData.data.user_role.replace(/^,|,$/g, '').split(',').map(role => parseInt(role, 10));
            this.quesForm.user_info.user_industry = parseInt(userData.data.user_industry)
          } else {
            this.shouldShowIsAgree = true;
            this.quesForm.user_info.user_id = ''
            this.quesForm.user_info.user_name = ''
            this.quesForm.user_info.register_country = ''
            this.quesForm.user_info.user_company = ''
            this.quesForm.user_info.user_job = ''
            this.quesForm.user_info.user_role = []
            this.quesForm.user_info.user_industry = ''
          }
          this.$refs.quesForm.clearValidate(["user_info.user_mobile", "user_info.user_email", "user_info.code", "user_info.user_mobile_area_code", "user_info.register_country", "user_info.user_company", "user_info.user_job", "user_info.user_role", "user_info.user_name"]); // 重置指定字段的验证
          //console.log(this.quesForm)
        }
      }
    },

    /**
     * 处理多选题选择变化
     */
    handleCheckboxChange(questionIndex, selectedValues) {
      const question = this.ques[questionIndex];
      const maxChoices = question.tqs_max_choices;

      // 如果设置了最大选择数量限制
      if (maxChoices && maxChoices > 0) {
        if (selectedValues.length > maxChoices) {
          // 如果超过最大选择数量，移除最后一个选择
          selectedValues.pop();
          this.quesForm.ques[questionIndex].tqa_tqo_id = [...selectedValues];
        }
      }
    },

    /**
     * 判断复选框是否应该被禁用
     */
    isCheckboxDisabled(questionIndex, optionId) {
      const question = this.ques[questionIndex];
      const maxChoices = question.tqs_max_choices;
      const currentSelections = this.quesForm.ques[questionIndex].tqa_tqo_id || [];

      // 如果没有设置最大选择数量，不禁用
      if (!maxChoices || maxChoices <= 0) {
        return false;
      }

      // 如果当前选项已经被选中，不禁用（允许取消选择）
      if (currentSelections.includes(optionId)) {
        return false;
      }

      // 如果已选择的数量达到最大值，禁用未选中的选项
      return currentSelections.length >= maxChoices;
    },

    /**
     * 提交问卷表单
     */
    resetForm() {
      this.$refs.quesForm.resetFields();
    },
    async subForm() {
      this.$refs.quesForm.validate(async (valid) => {
        let hasError = false;
        if (valid) {
          let params = { ...this.quesForm };
          this.$emit("submit", params);
        } else {
          this.$refs.quesForm.validateField(
            [
              "user_info.register_type",
              "user_info.user_mobile_area_code",
              "user_info.user_mobile",
              "user_info.code",
              "user_info.user_email",
              "user_info.user_name",
              "user_info.register_country",
              "user_info.user_company",
              "user_info.user_role",
              "user_info.user_industry",
            ],
            (err) => {
              if (err) {
                hasError = true;
                return;
              }
            }
          );
          if (!hasError) {
            this.$message.warning(this.$t('请完成问卷填写再提交'));
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .el-radio__label {
    white-space: normal;
  }

  .el-radio {
    align-items: start;
  }

  .el-radio__input {
    margin-top: 3px;
  }
}
</style>